import { render, staticRenderFns } from "./TaskPopOver.vue?vue&type=template&id=96ba6294&scoped=true&"
import script from "./TaskPopOver.vue?vue&type=script&lang=js&"
export * from "./TaskPopOver.vue?vue&type=script&lang=js&"
import style0 from "./TaskPopOver.vue?vue&type=style&index=0&id=96ba6294&scoped=true&lang=css&"
import style1 from "./TaskPopOver.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba6294",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VBadge,VBtn,VCard,VCardActions,VChip,VDivider,VIcon,VList,VListTile,VListTileContent,VListTileSubTitle,VListTileTitle,VMenu,VSpacer,VSubheader})
